import React from 'react';

import { Snippet as ArticleSnippetProps } from 'lib/sanity/types';
import BlockSerializer from 'lib/sanity/ui/BlockSerializer';

const ArticleSnippet = ({ snippet }: { snippet: ArticleSnippetProps | undefined }) => {
  if (!snippet?.content?.length) {
    return null;
  }

  return <BlockSerializer blocks={snippet.content} />;
};

export default ArticleSnippet;
